import { SchoolType, Title1Program, UIFilters } from '../types'
export * from '../types'

export type ExploreHighSchool = {
  id: string
  name: string
  city: string
  state: string
  schoolType?: SchoolType
  seniorClassSize?: number
  nextVisitDate?: string
  title1Program?: Title1Program
  pctFreeReducedLunch?: number
  isActive: boolean
  ceebCode?: string
  isTitle1Eligible?: boolean
  religiousAffiliation?: string
}

export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250, 500] as const
export const isValidPageSizeOption = (v: number): v is PageSizeOption => PAGE_SIZE_OPTIONS.includes(v as PageSizeOption)
export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number]

export type SortKey = Exclude<keyof ExploreHighSchool | 'distance', 'id'>
const allowedSortKeys: SortKey[] = [
  'name',
  'city',
  'schoolType',
  'seniorClassSize',
  'nextVisitDate',
  'state',
  'distance',
  'title1Program',
  'pctFreeReducedLunch',
  'isActive',
  'isTitle1Eligible',
  'religiousAffiliation',
]

export const stringAsValidSortKey = (v?: string): SortKey | undefined => {
  if (isValidSortKey(v)) {
    return v
  }
}
export const isValidSortKey = (v?: string): v is SortKey => allowedSortKeys.includes(v as SortKey)

export const isValidTitle1Program = (v?: string): v is UIFilters['title1Program'] => {
  return v === 'swp' || v === 'tas'
}
const allowedSortDirections = ['asc', 'desc'] as const
export type SortDirection = (typeof allowedSortDirections)[number]

export const stringAsSortDirection = (v?: string): SortDirection | undefined => {
  return isValidSortDirection(v) ? v : undefined
}
const isValidSortDirection = (v?: string): v is SortDirection => allowedSortDirections.includes(v as SortDirection)

export interface ResultOptions {
  from?: number
  limit: number
  sortKey: SortKey
  sortDirection: SortDirection
}

export const API_DATE_FORMAT = 'yyyy-MM-dd'
